import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import SuperSearchList from "../../shared/SuperSearch/SuperSearchList";
import DatePicker from "../../General/DatePicker";
import { GenderDemographic, Relationship, ServiceTypeCode } from "../../../utils/Constants";
import isNull from "../../../utils/NullChecking";
import EligiblityHistoryStatus from "../../Billing/Realtime/RealtimeDetails/Eligibility History/History/EligiblityHistoryStatus";
import { useSelector } from "react-redux";
import { enumUtil } from "../../../utils/Enum";
import FormValidator from "../../../utils/FormValidator";
import NotificationHandler from "../../../utils/NotificationHandler";
import { format } from "date-fns";
import { ServerRequestProtected } from "../../../utils/ServerDataRequest";
import Loader from "../../shared/Loader/Loader";
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import Pagination from "../../shared/Pagination/Pagination";
import NoDataFound from "../../shared/NoDataFound/NoDataFound";
import { FindFirstChild } from "../../../utils/FindMenuOption";
import EligiblityHistoryStatusTabs from "../../Billing/Realtime/RealtimeDetails/Eligibility History/History/EligibilityHistoryStatusTabs";

const InstantEligibility = (props) => {
    let FormatedDate = format(new Date, 'MM/dd/yyy')
    let InstantEligibility_model = {
        PATLastName: "",
        PATFirstName: "",
        PATMiddleInitial: "",
        PATDob: "",
        PATGender: "",

        SBRLastName: "",
        SBRFirstName: "",
        SBRMiddleInitial: "",
        SBRDob: "",
        SBRGender: "",

        PatientRelationValue: '',
        SubscriberID: "",
        ServiceTypeCode: "",
        EligiblityDate: '',
        InsuranceID: "",
        ProviderID: "",
    }
    let valModal = {}
    let ValidationModal = {
        Providerval: null,
        EligiblityDateval: null,
        InsuranceIDval: null,
        ServiceTypeCodeval: null,

        PatientRelationValueval: null,
        PATLastNameval: null,
        PATFirstNameval: null,
        PATDobval: null,
        SBRLastNameval: null,
        SBRFirstNameval: null,
        SBRDobval: null,

        SubscriberIDval: null,
    }
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    const API_URL_Eligibility = enumUtil.controller.Eligibility
    const API_URL = enumUtil.controller.General
    let isInstantViewAllowed = FindFirstChild('Patient', 'Instant Eligibility')?.IsAdd

    const { isOpenInstantEligibility, CloseInstantElibility } = { ...props }
    const [mainInstantEligibilityModal, setmainInstantEligibilityModal] = useState(InstantEligibility_model);
    const [saveInstantEligibilityModal, setSaveInstantEligibilityModal] = useState({});
    const [is, setIs] = useState(false);
    const [isSelfRelation, setIsSelfRelation] = useState(false);
    const [PatientValidationModal, setPatientValidationModal] = useState(ValidationModal)
    const [isLoading, setIsLoading] = useState(false)
    const [PatientEligigibilityID, setPatientEligigibilityID] = useState(0)
    const [PatientEligibillityHistory, setPatientEligibillityHistory] = useState([])

    const [reloadGrid, setReloadGrid] = useState(false)



    const getPatientHistory = () => {
        setIsLoading(true)
        ServerRequestProtected(API_URL + "/FindByMultipleCriteria", 'post', {
            "TableName": enumUtil.enumAPITableName.InstantEligibility,
            "PerPage": 100,
            "PageNo": 1
        }).then((response) => {
            setIsLoading(false)
            setPatientEligibillityHistory(response.Rows)
        }).catch((error) => {
            setIsLoading(false)
            setPatientEligibillityHistory([])
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
        })
    }
    useEffect(() => {
        setIs(true)
        let FormatedDate = format(new Date, 'MM/dd/yyy')
        setmainInstantEligibilityModal({
            ...mainInstantEligibilityModal,
            ProviderID: DropDowns?.Provider.length === 2 ? DropDowns?.Provider[1].display : '',
            PatientRelationValue: "18 - Self",
            EligiblityDate: FormatedDate,
            ServiceTypeCode: '30 - Health Benefit Plan Coverage'
        })
        setSaveInstantEligibilityModal({
            ...InstantEligibility_model,
            ProviderID: DropDowns?.Provider.length === 2 ? DropDowns?.Provider[1].value + "" : '-1',
            PatientRelationValue: "18",
            EligiblityDate: FormatedDate,
            UsePracticeNPI: "true",
            ServiceTypeCode: '30'
        })
        getPatientHistory()

    }, [])
    const handleChangeInstantEligibility = (e) => {
        setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainInstantEligibilityModal };
        let saveModal = { ...saveInstantEligibilityModal }
        modal[name] = value
        setmainInstantEligibilityModal(modal)
        for (var property in InstantEligibility_model) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setSaveInstantEligibilityModal(saveModal)
    }
    const handleDropDownChange = (e) => {
        setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainInstantEligibilityModal };
        modal[name] = value
        setmainInstantEligibilityModal(modal)
    }
    const handleCalendarChange = (date, type) => {
        var FormatedDate = date
        let modal = { ...mainInstantEligibilityModal };
        let saveModal = { ...saveInstantEligibilityModal }
        modal[type] = FormatedDate
        setmainInstantEligibilityModal(modal)
        for (var property in InstantEligibility_model) {
            if (type === property) {
                saveModal[type] = FormatedDate
            }
        }
        setSaveInstantEligibilityModal(saveModal)
    }
    const handleSelectedData = (selectedData, name, type) => {
        setIs(true)
        let modal = { ...mainInstantEligibilityModal };
        let saveModal = { ...saveInstantEligibilityModal };
        if (type === 'client' && !isNull(selectedData)) {
            if (name === 'PatientRelationValue') {
                setIsSelfRelation(selectedData.value === '18' ? false : true)
            }
            modal[name] = selectedData.display
            saveModal[name] = selectedData.value + "";
        } else if (type === 'server' && !isNull(selectedData)) {
            if (name === 'InsuranceID') {
                saveModal[name] = selectedData.value + "";
            }
        } else {
            modal[name] = ''
            saveModal[name] = ''
        }
        setmainInstantEligibilityModal(modal)
        setSaveInstantEligibilityModal(saveModal)
        return selectedData
    }
    const InstantEligibilityValidation = async () => {
        let ValidationModal = {
            PATFirstNameval: isSelfRelation ? FormValidator(
                mainInstantEligibilityModal.PATFirstName,
                enumUtil.enumValidationType.Required,
                'Pat. First Name',
            ) : null,
            PATLastNameval: isSelfRelation ? FormValidator(
                mainInstantEligibilityModal.PATLastName,
                enumUtil.enumValidationType.Required,
                'Pat. Last Name',
            ) : null,
            SubscriberIDval: FormValidator(
                mainInstantEligibilityModal.SubscriberID,
                enumUtil.enumValidationType.Required,
                'Subscriber ID',
            ),
            PatientRelationValueval: FormValidator(
                mainInstantEligibilityModal.PatientRelationValue,
                enumUtil.enumValidationType.Required,
                'Pat. Relation',
            ),
            Providerval: FormValidator(
                mainInstantEligibilityModal.ProviderID,
                enumUtil.enumValidationType.Required,
                'Provider',

            ),
            EligiblityDateval: FormValidator(
                mainInstantEligibilityModal.EligiblityDate,
                enumUtil.enumValidationType.Required,
                'Service Date',
            ),
            InsuranceIDval: FormValidator(
                mainInstantEligibilityModal.InsuranceID,
                enumUtil.enumValidationType.Required,
                'Insurance',
            ),

            ServiceTypeCodeval: FormValidator(
                mainInstantEligibilityModal.ServiceTypeCode,
                enumUtil.enumValidationType.Required,
                'Service Type Code',
            ),
            SBRFirstNameval: FormValidator(
                mainInstantEligibilityModal.SBRFirstName,
                enumUtil.enumValidationType.Required,
                'First Name',
            ),
            SBRLastNameval: FormValidator(
                mainInstantEligibilityModal.SBRLastName,
                enumUtil.enumValidationType.Required,
                'Last Name',
            ),

        }
        await setPatientValidationModal(ValidationModal)
        valModal = ValidationModal

    }
    const handlePerformInstantEligibility = async () => {
        if (isInstantViewAllowed) {
            await InstantEligibilityValidation()
            let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
            if (validation) {
                NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
                return
            } else {
                setIsLoading(true)
                ServerRequestProtected(API_URL_Eligibility + "/InstantEligibilityRequest", 'post', {
                    "TableName": enumUtil.enumAPITableName.INSTANTGENERATE270,
                    "data": [saveInstantEligibilityModal],
                })
                    .then((response) => {
                        setIsLoading(false)
                        setPatientEligigibilityID(response.patientEligibiltyID)
                        setEligibilityPopup(true)
                    }).catch((error) => {
                        setIsLoading(false)
                        NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                    })
            }
        }
    }
    const [EligibilityPopup, setEligibilityPopup] = useState(false);
    const CloseEligibilityPopup = () => {
        setEligibilityPopup(false)
    }
    const [showEligibilityHistory, setShowEligibilityHistory] = useState(false)
    const [id, setId] = useState()


    const handleOpenEligHistStat = (id) => {
        // setId(id);
        setPatientEligigibilityID(id);
        setEligibilityPopup(true);
    }
    // let EligibilityHistoryPopup 
    // if (showEligibilityHistory) {
    //     EligibilityHistoryPopup = <EligiblityHistoryStatusTabs setReloadGrid={setReloadGrid} setShowEligibilityHistory={setShowEligibilityHistory} id={id} />
    // }
    return (
        <>
            {/* {showEligibilityHistory && <EligiblityHistoryStatusTabs setReloadGrid={setReloadGrid} setShowEligibilityHistory={setShowEligibilityHistory} id={id} />} */}
            <Modal show={isOpenInstantEligibility} onHide={CloseInstantElibility} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 table-default-design ar-Perform-Instant-Eligibility">
                <Modal.Body>
                    {/* {EligibilityHistoryPopup} */}
                    {isLoading ? <Loader /> : null}
                    <div className="d-flex align-items-center justify-content-between mb-12">
                        <p className="heading dark-clr fs-14">Perform Instant Eligibility</p>
                        <i className="icon-x-cros fs-20 dark-clr" onClick={CloseInstantElibility}></i>
                    </div>
                    <div className="">
                        <Tab.Container defaultActiveKey="InstantEligibility">
                            <div className="add_new_insurance">
                                <div className="content mb-12">
                                    <Nav variant="tabs" className="d-flex border-0 gx-0 gap-15" >
                                        <Nav.Item>
                                            <Nav.Link eventKey="InstantEligibility"><span className="heading me-1 font-m">Auto</span></Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="History"><span className="heading font-m">History</span></Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </div>
                            </div>
                            <div className='ar_tabsData-content'>
                                <Tab.Content>
                                    <Tab.Pane eventKey="InstantEligibility">
                                        <div>
                                            <div className="row m-0 g-0 row-gap-8">
                                                <div className="col-md-6 pe-1-5">
                                                    <div className={PatientValidationModal.InsuranceIDval ? 'input error' : 'input'}>
                                                        <label>Insurance <span className='req'>*</span></label>
                                                        <SuperSearchList
                                                            type="client"
                                                            id='InsuranceID'
                                                            name='InsuranceID'
                                                            sup_btn='sup_btn-Inp'
                                                            sup_inp='superSearchVisitInp'
                                                            searchValue={mainInstantEligibilityModal.InsuranceID}
                                                            data={DropDowns.Insurance.length > 0 ? DropDowns.Insurance.filter(x => x.value !== 'SELFPAY') : []}
                                                            onChange={handleDropDownChange}
                                                            getSelectedData={handleSelectedData}
                                                            is={is}
                                                            inputError={PatientValidationModal.InsuranceIDval}
                                                        />
                                                        {PatientValidationModal.InsuranceIDval}
                                                    </div>
                                                </div>
                                                <div className="col-md-6 ps-1-5">
                                                    <div className={PatientValidationModal.InsuranceIDval ? 'input error' : 'input'}>
                                                        <label>Service Type Code <span className='req'>*</span></label>
                                                        <SuperSearchList
                                                            type="client"
                                                            id='ServiceTypeCode'
                                                            name='ServiceTypeCode'
                                                            sup_btn='sup_btn-Inp'
                                                            sup_inp='superSearchVisitInp'
                                                            searchValue={mainInstantEligibilityModal.ServiceTypeCode}
                                                            data={ServiceTypeCode}
                                                            onChange={handleDropDownChange}
                                                            getSelectedData={handleSelectedData}
                                                            is={is}
                                                            inputError={PatientValidationModal.ServiceTypeCodeval}
                                                        />
                                                        {PatientValidationModal.ServiceTypeCodeval}
                                                    </div>
                                                </div>
                                                <div className="col-md-6 pe-1-5">
                                                    <div className={PatientValidationModal.Providerval ? 'input error' : 'input'}>
                                                        <label>Provider <span className='req'>*</span></label>
                                                        <SuperSearchList
                                                            type="client"
                                                            id='ProviderID'
                                                            name='ProviderID'
                                                            sup_btn='sup_btn-Inp'
                                                            sup_inp='superSearchVisitInp'
                                                            searchValue={mainInstantEligibilityModal.ProviderID}
                                                            data={DropDowns.Provider}
                                                            onChange={handleDropDownChange}
                                                            getSelectedData={handleSelectedData}
                                                            is={is}
                                                            inputError={PatientValidationModal.Providerval}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6 ps-1-5">
                                                    <div className='input'>
                                                        <label htmlFor="EligiblityDate">Service Date <span className='req'>*</span></label>
                                                        <DatePicker
                                                            id="EligiblityDate"
                                                            value={mainInstantEligibilityModal.EligiblityDate}
                                                            handleCalendarChangefunc={date => handleCalendarChange(date, 'EligiblityDate')}
                                                            inputError={PatientValidationModal.EligiblityDateval}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="pateint_information">
                                                <p className="text font-m mb-2">Patient Information</p>
                                                <div className="row m-0 row-gap-8">
                                                    <div className="col-md-4 ps-0">
                                                        <div className={PatientValidationModal.PatientRelationValueval ? 'input error' : 'input'}>
                                                            <label>Pat. Relation <span className='req'>*</span></label>
                                                            <SuperSearchList
                                                                type="client"
                                                                id='PatientRelationValue'
                                                                name='PatientRelationValue'
                                                                searchValue={mainInstantEligibilityModal.PatientRelationValue}
                                                                data={Relationship}
                                                                onChange={handleDropDownChange}
                                                                getSelectedData={handleSelectedData}
                                                                is={is}
                                                                sup_btn='sup_btn-Inp'
                                                                sup_inp='superSearchVisitInp'
                                                                inputError={PatientValidationModal.PatientRelationValueval}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 ps-0">
                                                        <div className={PatientValidationModal.SubscriberIDval ? 'input error' : 'input'}>
                                                            <label>Subscriber ID <span className='req'>*</span></label>
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                name="SubscriberID"
                                                                id="SubscriberID"
                                                                autoComplete="off"
                                                                value={mainInstantEligibilityModal.SubscriberID}
                                                                onChange={handleChangeInstantEligibility}
                                                            />
                                                            {PatientValidationModal.SubscriberIDval}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 ps-0">
                                                        <div className={PatientValidationModal.SBRLastNameval ? 'input error' : 'input'}>
                                                            <label>Last Name <span className='req'>*</span></label>
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                name="SBRLastName"
                                                                id="SBRLastName"
                                                                autoComplete="off"
                                                                value={mainInstantEligibilityModal.SBRLastName}
                                                                onChange={handleChangeInstantEligibility}
                                                            />
                                                            {PatientValidationModal.SBRLastNameval}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 ps-0">
                                                        <div className={PatientValidationModal.SBRFirstNameval ? 'input error' : 'input'}>
                                                            <label>First Name <span className='req'>*</span></label>
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                name="SBRFirstName"
                                                                id="SBRFirstName"
                                                                autoComplete="off"
                                                                value={mainInstantEligibilityModal.SBRFirstName}
                                                                onChange={handleChangeInstantEligibility}
                                                            />
                                                            {PatientValidationModal.SBRFirstNameval}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 ps-0">
                                                        <div className='input'>
                                                            <label>Middle Initial</label>
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                name="SBRMiddleInitial"
                                                                id="SBRMiddleInitial"
                                                                autoComplete="off"
                                                                value={mainInstantEligibilityModal.SBRMiddleInitial}
                                                                onChange={handleChangeInstantEligibility}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 ps-0">
                                                        <div className={PatientValidationModal.SBRDobval ? 'input error' : 'input'}>
                                                            <label htmlFor="SBRDob">DOB </label>
                                                            <DatePicker
                                                                id="SBRDob"
                                                                value={mainInstantEligibilityModal.SBRDob}
                                                                handleCalendarChangefunc={date => handleCalendarChange(date, 'SBRDob')}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 ps-0">
                                                        <div className='input'>
                                                            <label>Sex</label>
                                                            <SuperSearchList
                                                                type="client"
                                                                id='SBRGender'
                                                                name='SBRGender'
                                                                sup_btn='sup_btn-Inp'
                                                                sup_inp='superSearchVisitInp'
                                                                searchValue={mainInstantEligibilityModal.SBRGender}
                                                                data={GenderDemographic}
                                                                onChange={handleDropDownChange}
                                                                getSelectedData={handleSelectedData}
                                                                is={is}
                                                            />
                                                        </div>
                                                    </div>
                                                    {isSelfRelation === true &&
                                                        <>
                                                            <div className="col-md-4 px-0">
                                                                <div className={PatientValidationModal.PATLastNameval ? 'input error' : 'input'}>
                                                                    <label>Pat. Last Name <span className='req'>*</span></label>
                                                                    <input
                                                                        type="text"
                                                                        className='form-control'
                                                                        name="PATLastName"
                                                                        id="PATLastName"
                                                                        autoComplete="off"
                                                                        value={mainInstantEligibilityModal.PATLastName}
                                                                        onChange={handleChangeInstantEligibility}
                                                                    />
                                                                    {PatientValidationModal.PATLastNameval}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4 pe-0">
                                                                <div className={PatientValidationModal.PATFirstNameval ? 'input error' : 'input'}>
                                                                    <label>Pat. First Name <span className='req'>*</span></label>
                                                                    <input
                                                                        type="text"
                                                                        className='form-control'
                                                                        name="PATFirstName"
                                                                        id="PATFirstName"
                                                                        autoComplete="off"
                                                                        value={mainInstantEligibilityModal.PATFirstName}
                                                                        onChange={handleChangeInstantEligibility}
                                                                    />
                                                                    {PatientValidationModal.PATFirstNameval}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4 ps-0">
                                                                <div className='input'>
                                                                    <label>Pat. Middle Initial</label>
                                                                    <input
                                                                        type="text"
                                                                        className='form-control'
                                                                        name="PATMiddleInitial"
                                                                        id="PATMiddleInitial"
                                                                        autoComplete="off"
                                                                        value={mainInstantEligibilityModal.PATMiddleInitial}
                                                                        onChange={handleChangeInstantEligibility}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4 px-0">
                                                                <div className={PatientValidationModal.PATDobval ? 'input error' : 'input'}>
                                                                    <label htmlFor="PATDob">Pat. DOB</label>
                                                                    <DatePicker
                                                                        id="PATDob"
                                                                        value={mainInstantEligibilityModal.PATDob}
                                                                        handleCalendarChangefunc={date => handleCalendarChange(date, 'PATDob')}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4 pe-0">
                                                                <div className='input'>
                                                                    <label>Pat. Sex</label>
                                                                    <SuperSearchList
                                                                        type="client"
                                                                        id='PATGender'
                                                                        name='PATGender'
                                                                        sup_btn='sup_btn-Inp'
                                                                        sup_inp='superSearchVisitInp'
                                                                        searchValue={mainInstantEligibilityModal.PATGender}
                                                                        data={GenderDemographic}
                                                                        onChange={handleDropDownChange}
                                                                        getSelectedData={handleSelectedData}
                                                                        is={is}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="History" className="history-content">
                                        <div className=" hk-expand-table overflow-auto BorderLess-table history-table">
                                            <table className='w-100' >
                                                <thead>
                                                    <tr>
                                                        <th>Transaction Date</th>
                                                        <th>Patient Name</th>
                                                        <th>Account #</th>
                                                        <th>Subscriber</th>
                                                        <th>Sub. ID</th>
                                                        <th>Eligibility Date</th>
                                                        <th>Eligibility By</th>

                                                        <th>Payer</th>
                                                        <th>Provider</th>
                                                        <th>Status</th>
                                                        <th>Reason</th>
                                                        <th>Copay</th>
                                                        <th>SpecialistCopay</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <NoDataFound isLoading={isLoading} rows={PatientEligibillityHistory} />

                                                    {PatientEligibillityHistory && PatientEligibillityHistory.map((item) => (
                                                        <tr key={item.id}>
                                                            <td className='cursor-pointer' onClick={() => handleOpenEligHistStat(item.ID)}>
                                                                <div className="cursor-pointer grid-hover-text text fs-12">
                                                                    {item.TransactionDate}
                                                                </div>
                                                            </td>
                                                            <td>{item.Patient}</td>
                                                            <td>{item.AccountNumber}</td>
                                                            <td>{item.Subscriber}</td>
                                                            <td>{item.SubscriberID}</td>
                                                            <td>{item.EligibilityDate}</td>
                                                            <td>{item.EnteredBy}</td>
                                                            <td>{item.Payer}</td>
                                                            <td>{item.Provider}</td>
                                                            <td>
                                                                {item.Status === 'Active' ? <i className='pill ar-user_active'>{item.Status}</i> :
                                                                    item.Status === 'InActive' ? <i className='pill ar-user_active inactive-clr'>{item.Status}</i> :
                                                                        item.Status === 'Rejected' ? <i className='pill ar-user_active Rejected-by-Payer'>{item.Status}</i> :
                                                                            item.Status === 'Active (Other)' ? <i className='pill ar-user_active '>{item.Status}</i> :
                                                                                item.Status === 'Failed' ? <div className="pill ar-user_active Partialdenied ">{item.Status}</div> : <></>}
                                                            </td>
                                                            <td>{item.Reason}</td>
                                                            <td>{item.Copay}</td>
                                                            <td>{item.SpecialistCopay}</td>

                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <Pagination
                                            disableInput={true}
                                        />
                                    </Tab.Pane>
                                </Tab.Content>
                            </div>
                        </Tab.Container>
                    </div>
                </Modal.Body>
                <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                    <button className={isInstantViewAllowed ? 'btn btn-validate px-10 h-100' : 'btn btn-validate px-10 h-100 disabled'}
                        onClick={handlePerformInstantEligibility}>Perform Eligibility </button>
                </div>
            </Modal>
            <Modal show={EligibilityPopup} onHide={CloseEligibilityPopup} backdrop="static" keyboard={false} centered className='app-modal modal modal-dialog-centered modal-lg add_new_eligibility hk-modal-v1'>
                <Modal.Body className='pb-4'>
                    <div className='d-flex justify-content-end' onClick={() => setEligibilityPopup(false)}>
                        <button className="btn-icon-transparent">
                            <i className="icon-Icon-metro-cross"></i>
                        </button>
                    </div>
                    <EligiblityHistoryStatus type={'InstantEligibility'} id={PatientEligigibilityID} />
                </Modal.Body>
            </Modal>
        </>
    )
}
export default InstantEligibility